import React, { useState, useEffect } from 'react'
import Modal from 'layouts/Modal/Modal';
import Axios from 'middleware/axiosInstance';
import Loading from 'layouts/Loading/Loading';
import ButtonComponent from 'components/Form/ButtonComponent';
import InputComponent from 'components/Form/InputComponent';
import OpenNotificationWithIcon from 'layouts/notificationWithIcon/OpenNotificationWithIcon ';

const GroupPeople = () => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [newGrouppeople, setNewGrouppeople] = useState({})
  const [editGrouppeople, setEditeGrouppeople] = useState({})
  const [allGrouppeople, setAllGrouppeople] = useState(null)

  const CreateGroupPeopleHandler = (e) => {
    e.preventDefault();
    Axios.post(`g_people`, newGrouppeople)
      .then((res) => {
        console.log(res)
        OpenNotificationWithIcon("ثبت موفق", "گروه اشخاص جدید با موفقیت ثبت شد")
        setShowAddModal(false)
        setNewGrouppeople(null)
      }).catch((err) => {
        console.log(err.response.status)
        OpenNotificationWithIcon("خطا", "گروه اشخاص ثبت نشد", "error")
      }).finally(() => {
        getAllGroupPeople()
      })

  }
  const editeGroupPeopleHandler = () => {
    Axios.put(`g_people/${selectedItem.id}`, editGrouppeople)
      .then((res) => {
        console.log(res);
        OpenNotificationWithIcon("ویرایش", "گروه اشخاص ویرایش شد")
      })
      .catch(() => {
        OpenNotificationWithIcon("خطا", "گروه اشخاص ویرایش نشد", "error")
      })
      .finally(() => {
        getAllGroupPeople();
        setShowEditModal(false)
        setSelectedItem(null)
        setEditeGrouppeople(null)
      }
      )
  }

  const getAllGroupPeople = () => {
    Axios.get("g_people")
      .then((res) => {
        setAllGrouppeople(res.data)
      })
      .catch(() => {
        OpenNotificationWithIcon("خطا در دیافت اطلاعات", "لیست گروه اشخاص دریافت نشد", "error")
      })
  }

  const deleteGroupPeopleHandler = () => {
    Axios.delete(`g_people/${selectedItem.id}`)
      .then((res) => {
        console.log(res);
        getAllGroupPeople();
        setShowAddModal(false)
        OpenNotificationWithIcon("موفق", "گروه اشخاص حذف شد")
      })
      .catch(() => {
        OpenNotificationWithIcon("خطا", "گروه اشخاص حذف نشد", "error")
      })
      .finally(() => {
        setSelectedItem(null)
      })
  }


  useEffect(() => {
    getAllGroupPeople();
  }, []);


  const handleSelectRow = (item) => {
    setSelectedItem(item)
  }

  const deleteItemHandler = () => {
    if (window.confirm(`آیا  گروه اشخاص "${selectedItem.name}" حذف گردد؟ \n\n هشدار: \n تمام اشخاص مربوط به این گروه نیز حذف می گردد!\n و اسناد مربوط به این اشخاص نیز حذف می گردند!`)) {
      deleteGroupPeopleHandler();
    }
  }

  const changeInputHandler = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    setNewGrouppeople({ ...newGrouppeople, [name]: value });
  }

  const changeEditeHandler = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    setEditeGrouppeople({ ...editGrouppeople, [name]: value });
  }
  return (
    <div className="customized-container">
      <div className="customized-wrapper">
        {showAddModal && <Modal >
          <form className='p-4'>
            <h6 className='text-center mt-2'>
              ایجاد یک گروه اشخاص:
            </h6>
            <InputComponent
              lableValue="نام:"
              inputType="text"
              onChange={changeInputHandler}
              inputName="name"
              inputPlaceholder="کارکنان اداری"
            />
            <InputComponent
              lableValue="توضیحات:"
              inputType="text"
              onChange={changeInputHandler}
              inputName="description"
              inputPlaceholder="توضیحات گروه ..."
            />
            <div className='d-flex justify-content-evenly  flex-wrap mt-4'>

              <ButtonComponent value="ثبت" onClick={(e) => CreateGroupPeopleHandler(e)} />
              <ButtonComponent value="انصراف" onClick={() => setShowAddModal(false)} />
            </div>
          </form>
        </Modal>}

        {showEditModal && <Modal >
          <div className='p-4'>

            <h6 className='text-center mt-2'>
              ویرایش گروه اشخاص
              {` ${selectedItem.name}: `}
            </h6>
            <InputComponent
              lableValue="نام:"
              inputType="text"
              onChange={changeEditeHandler}
              inputName="name"
              defaultValue={selectedItem.name}
            />
            <InputComponent
              lableValue="توضیحات:"
              inputType="text"
              onChange={changeEditeHandler}
              inputName="description"
              defaultValue={selectedItem.description}
            />
            <div className='d-flex justify-content-evenly  flex-wrap mt-4'>
              <ButtonComponent value="ثبت" onClick={() => editeGroupPeopleHandler()} />
              <ButtonComponent value="انصراف" onClick={() => setShowEditModal(false)} />
            </div>
          </div>
        </Modal>}

        <h5 className="title-session">
          گروه اشخاص
        </h5>
        <div className='d-flex flex-row '>
          <button className='bi-custom-button'
            onClick={() => setShowAddModal(true)}
          >اضافه کردن</button>
          <button className='bi-custom-button'
            onClick={() => selectedItem ? setShowEditModal(true) :
              OpenNotificationWithIcon("خطا", "جهت ویرایش  یک آیتم را انتخاب فرمایید", "error")
            }
          >ویرایش</button>
          <button className='bi-custom-button'
            onClick={() => selectedItem ? deleteItemHandler() :
              OpenNotificationWithIcon("خطا", "جهت حذف  یک آیتم را انتخاب فرمایید", "error")
            }
          >حذف</button>
        </div>
        <>
          {allGrouppeople === null ?
            <Loading />
            :
            <table className="bi-table-style bi-row-select-enable col-12 col-md-6 col-lg-4">
              <thead>
                <tr>
                  <th >آیدی</th>
                  <th >نام</th>
                  <th >توضیحات</th>
                </tr>
              </thead>
              <tbody>
                {allGrouppeople.map((Grouppeople, index) => {
                  return (
                    <tr id={Grouppeople.id}
                      onClick={() => handleSelectRow(Grouppeople)}
                      className={selectedItem?.id === Grouppeople.id ? "item-slected" : null}>
                      <td >
                        {index + 1}
                      </td>
                      <td>
                        {Grouppeople.name}
                      </td>
                      <td>
                        {Grouppeople.description}
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          }
        </>
      </div>
    </div>
  )
}
export default GroupPeople